import axios from 'axios';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';
import { copyToClipboard } from '@services/utilityService';
import { authService } from '@features/auth/services/authService';

export async function fetchGuestLink(
  guestId: number,
  idType: 'customer' | 'guestride'
): Promise<string | null> {
  const token = await authService.getAccessTokenWithAutoRefresh();
  if (!token) {
    toast.error('You must be signed in to generate a guest link');
    return null;
  }

  const { data } = await axios.post(
    '/.netlify/functions/generateGuestLink',
    {
      guest_id: guestId,
      id_type: idType,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  if (data?.success && data?.url) {
    return data.url as string;
  }
  return null;
}

export async function generateAndCopyGuestLink(
  guestId: number,
  idType: 'customer' | 'guestride'
): Promise<void> {
  try {
    const url = await fetchGuestLink(guestId, idType);
    if (url) {
      copyToClipboard(url);
    } else {
      toast.error('Failed to generate guest link');
    }
  } catch (err) {
    console.error('Failed to generate guest link:', err);
    Sentry.captureException(err, {
      tags: { feature: 'guest-rides', action: 'copy-guest-link' },
      extra: { guestId, idType },
    });
    toast.error('Failed to generate guest link');
  }
}
